import authService from '../services/AuthService';
import { logoutSession } from './auth';
import listenerManager from '../services/ListenerManager';
import logger from '../services/Logger';
import { getSessionToken, invalidateAuthSession } from '../services/AuthSession';

export const logout = async () => {
  try {
    const sessionToken = getSessionToken();

    // Cleanup all listeners before logout
    await listenerManager.cleanup();

    // Sign out from provider and invalidate local session BEFORE network calls
    // so neither this tab nor other tabs can race to auto-recover the session.
    try {
      await authService.signOut();
    } catch (error) {
      logger.warn('logout', 'User already signed out');
    }

    invalidateAuthSession({
      reason: 'explicit_logout',
      source: 'logout',
      expectedToken: getSessionToken(),
      notifyCurrentTab: false,
    });

    // Call backend logout endpoint
    if (sessionToken) {
      try {
        await logoutSession(sessionToken);
      } catch (error) {
        logger.error('logout', 'Backend logout failed', { error: error.message });
      }
    }

    try {
      await fetch('/docs/api/auth/session', { method: 'DELETE' });
    } catch (error) {
      logger.warn('logout', 'Docs session cleanup failed', { error: error.message });
    }

    window.location.href = "/";
  } catch (error) {
    logger.error('logout', 'Logout failed', { error: error.message });
  }
};
